// The text of the coming-soon window for each feature the sidebar shows before
// it is built. It comes from the feature's HQ card. A click on the item also
// counts as demand: POST /feature-interactions/coming_soon_<key>/seen.
export const COMING_SOON = {
  live_now: {
    title: 'Live now',
    text: 'A 15 minute video call with a mentor who is free right now.',
    points: [
      'See which mentors can talk now.',
      'One tap starts the call.',
      'You do not book a time and you do not wait.',
    ],
  },
  people: {
    title: 'People',
    text: 'One page with every kind of person you can book a call with.',
    points: [
      'Mentors come first. Then peers, investors and people who hire.',
      'Each person has one booking action that fits them.',
      'You choose where people can find you, and you set a monthly limit.',
    ],
  },
  cities: {
    title: 'Cities',
    text: 'Members in one city meet in person: a coffee, a walk or a coworking afternoon.',
    points: [
      'Every City Squads city gets its own page.',
      'Paid members and mentors host free events near home.',
      'London is first.',
    ],
  },
  work: {
    title: 'Work',
    text: 'Roles and projects from the companies of our members.',
    points: [
      'Members post a role and explain the work.',
      'You send a private note to the person who posted it.',
      'GrowthMentor takes no fee on the work you find here.',
    ],
  },
  startups: {
    title: 'Startups',
    text: 'A page for the business you build: what it does, who builds it, and what would help now.',
    points: [
      'You choose who sees the page.',
      'A mentor reads it before your call and comes prepared.',
      'When you raise money, you can open it to investors.',
    ],
  },
  adventures: {
    title: 'Adventures',
    text: 'Hard things members and mentors are doing this year, with a few places for a crew.',
    points: [
      'A marathon, a trek or a climb, posted by the member who is going.',
      'The host picks a small crew from the people who apply.',
      'The crew plans together in a group chat before the trip.',
    ],
  },
  blue_chip: {
    title: 'Blue Chip',
    text: 'Your Blue Chip score, and every event behind it.',
    points: [
      'See how fast you answer session requests.',
      'See how many accepted calls you hold.',
      'See how far you are from the threshold.',
    ],
  },
  practice: {
    title: 'Your practice',
    text: 'Your best methods and ideas from every recorded call, on a private page.',
    points: [
      'Each recorded call adds a note or makes one stronger.',
      'You can correct, hide or save each note.',
      'Only you see this page.',
    ],
  },
} as const

export type ComingSoonKey = keyof typeof COMING_SOON
